import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import formValueSelector from 'redux-form/es/formValueSelector';
import { getContractData, getStatementOfAccount } from 'actions/selfservice';
import history from 'router/history';
import StatementOfAccountForm from 'components/Credit24/SelfService/StatementOfAccount/StatementOfAccountForm';
import StatementOfAccount from 'components/Credit24/SelfService/StatementOfAccount';

const propTypes = {
  selfservice: PropTypes.object,
  authentication: PropTypes.object,
  getStatementOfAccount: PropTypes.func,
  selectedYear: PropTypes.string,
  getContractData: PropTypes.func,
};

class StatementOfAccountContainer extends Component {
  componentDidMount() {
    this.props.authentication.contracts.forEach((contractId) => {
      this.props.getContractData(contractId, false, (contract) => {
        if (COUNTRY === 'AU') {
          if (contract.product.type === 'INSTALLMENT') {
            history.replace('/dashboard');
          }
        }
      });
    });

    const yearNow = new Date().getFullYear();
    const otherYears = [...Array(yearNow - 2018).keys()].map((no) => yearNow - no - 1);

    this.props.getStatementOfAccount([yearNow], false).then(
      () => this.props.getStatementOfAccount(otherYears, true)
    );
  }

  render() {
    const { selfservice, authentication, selectedYear } = this.props;
    const contractId = authentication.contracts && authentication.contracts[0];
    const contract = selfservice.contracts[contractId];
    let isProductLoadedAU = true;
    if (COUNTRY === 'AU') {
      isProductLoadedAU = !!(contract && contract.product);
    }

    if (!isProductLoadedAU) {
      return (
        <div />
      );
    }

    const { statements, areStatementsLoaded } = selfservice;
    const statementsArray = statements[selectedYear] || [];

    const yearsArray = Object.keys(statements)
      .map((year) => ({ type: year, title: year }))
      .reverse();

    const selectorDisabled = !areStatementsLoaded;

    return (
      <div className="content-block">
        <StatementOfAccountForm
          accountYears={yearsArray}
          selectorDisabled={selectorDisabled}
        />
        <div className="content-block__full-child">
          <StatementOfAccount statements={statementsArray} />
        </div>
      </div>
    );
  }
}

StatementOfAccountContainer.propTypes = propTypes;

const selector = formValueSelector('statementOfAccountForm');

export default connect(
  (state) => ({
    selfservice: state.selfservice,
    authentication: state.authentication,
    selectedYear: selector(
      state,
      'accountYear'
    ),
  }),
  { getStatementOfAccount, getContractData }
)(StatementOfAccountContainer);
